/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import { FormattedMessage } from 'react-intl';
import { EmptyCard } from '../../../components/card/Card';
import PreformattedText from '../../../components/PreformattedText';
import { MailToLink } from '../../../components/TextLink';
import Spacer from '../../../components/Spacer';
import ContentWrapper from '../../../components/ContentWrapper';

const DataConnectionNotAllowed = () => {
  return (
    <ContentWrapper isFlatContent={true}>
      <EmptyCard>
        <div className="font-headline font-color-profile">
          <FormattedMessage id="dataConnections.zero.countryNotSupported.heading" />
        </div>

        <Spacer size="8">
          <PreformattedText >
            <div className="font-subhead font-color-gsDark">
              <FormattedMessage id="dataConnections.zero.countryNotSupported.text.pre" />
            </div>
          </PreformattedText>
        </Spacer>
      </EmptyCard>
    </ContentWrapper>
  );
};

export default DataConnectionNotAllowed;
